import React from 'react';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import _ from 'lodash';

const RawFileInput = ({ name, value, placeholder, removable, remove, ...otherInputProps }) => (
  <div className="FileInput">
    <div className="FileInput-container">
      {/* Actual file input */}
      <input id={name} name={name} type="file" className="FileInput-file" {...otherInputProps} />

      {/* Emulated file input, for styling */}
      <input
        type="text"
        tabIndex={-1}
        value={_.map(value, file => file.name).join(', ')}
        placeholder={placeholder}
        className="FileInput-text"
      />
    </div>
    {removable ? (
      <a className="hyperlink" onClick={remove}>
        remove
      </a>
    ) : null}
  </div>
);

RawFileInput.displayNAme = 'RawFileInput';

export { RawFileInput };

const FileInput = connectFormComponentToReduxForm(wrapFormComponentWithError(RawFileInput));
FileInput.displayName = 'FileInput';
export { FileInput };

const RawFileField = wrapFormComponentWithLabelAndError(RawFileInput);
RawFileField.displayName = 'RawFileField';

export { RawFileField };

const FileField = connectFormComponentToReduxForm(RawFileField);
FileField.displayName = 'FileField';

export default FileField;
